<template>
  <v-container>
    <Header name="Service Requests" />

    <v-subheader>Pending ACE action</v-subheader>
    <div
      v-for="(project, index) in ongoingRequests"
      :key="project.ServiceRequestNumber"
    >
      <v-card
        color="orange lighten-4"
        @click="$router.push('/service/view/' + project.ServiceRequestNumber)"
      >
        <v-card-title>{{ project.ServiceRequestNumber }}</v-card-title>
        <v-card-text>
          <v-menu
            v-model="menu[index]"
            bottom
            right
            transition="scale-transition"
            origin="top left"
          >
            <template v-slot:activator="{ on }">
              <v-chip pill v-on="on">
                {{ getCompanyInfo(project.CustNumber).Office_Name }}
              </v-chip>
            </template>
            <v-card width="300">
              <v-list dark>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      getCompanyInfo(project.CustNumber)
                        ? getCompanyInfo(project.CustNumber).Office_Name
                        : "Unnamed company"
                    }}</v-list-item-title>
                    <v-list-item-subtitle
                      >#{{ getCompanyInfo(project.CustNumber).CustNumber }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="menu[index] = false">
                      <v-icon>mdi-close-circle</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-action>
                  <v-list-item-subtitle>{{
                    getCompanyInfo(project.CustNumber).Office_Contact_Name
                  }}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-phone</v-icon>
                  </v-list-item-action>
                  <v-list-item-subtitle>{{
                    getCompanyInfo(project.CustNumber)
                      .Office_Contact_PhoneNumber
                  }}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-btn
                    @click="
                      $router.push(
                        '/company/' +
                          getCompanyInfo(project.CustNumber).CustNumber
                      )
                    "
                    block
                    text
                    >Edit</v-btn
                  >
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
          · {{ project.ProductModel || "No product" }} ·
          {{ project.ProductSerialNumber || "Unknown S/N" }}
        </v-card-text>
      </v-card>
      <br />
    </div>
    <v-divider></v-divider>
    <v-subheader>Pending customer action</v-subheader>
    <div
      v-for="(project, index) in awaitingRequests"
      :key="project.ServiceRequestNumber"
    >
      <v-card
        color="grey lighten-3"
        @click="$router.push('/service/view/' + project.ServiceRequestNumber)"
      >
        <v-card-title>{{ project.ServiceRequestNumber }}</v-card-title>
        <v-card-text>
          <v-menu
            v-model="menu[index]"
            bottom
            right
            transition="scale-transition"
            origin="top left"
          >
            <template v-slot:activator="{ on }">
              <v-chip pill v-on="on">
                {{ getCompanyInfo(project.CustNumber).Office_Name }}
              </v-chip>
            </template>
            <v-card width="300">
              <v-list dark>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      getCompanyInfo(project.CustNumber)
                        ? getCompanyInfo(project.CustNumber).Office_Name
                        : "Unnamed company"
                    }}</v-list-item-title>
                    <v-list-item-subtitle
                      >#{{ getCompanyInfo(project.CustNumber).CustNumber }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="menu[index] = false">
                      <v-icon>mdi-close-circle</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-action>
                  <v-list-item-subtitle>{{
                    getCompanyInfo(project.CustNumber).Office_Contact_Name
                  }}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-phone</v-icon>
                  </v-list-item-action>
                  <v-list-item-subtitle>{{
                    getCompanyInfo(project.CustNumber)
                      .Office_Contact_PhoneNumber
                  }}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-btn
                    @click="
                      $router.push(
                        '/company/' +
                          getCompanyInfo(project.CustNumber).CustNumber
                      )
                    "
                    block
                    text
                    >Edit</v-btn
                  >
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
          · {{ project.ProductModel || "No product" }} ·
          {{ project.ProductSerialNumber || "Unknown S/N" }}
        </v-card-text>
      </v-card>
      <br />
    </div>
    <v-divider></v-divider>
    <v-subheader>Finished requests</v-subheader>
    <div
      v-for="(project, index) in finishedRequests"
      :key="project.ServiceRequestNumber"
    >
      <v-card
        color="green lighten-4"
        @click="$router.push('/service/view/' + project.ServiceRequestNumber)"
      >
        <v-card-title>{{ project.ServiceRequestNumber }}</v-card-title>
        <v-card-text>
          <v-menu
            v-model="menu[index]"
            bottom
            right
            transition="scale-transition"
            origin="top left"
          >
            <template v-slot:activator="{ on }">
              <v-chip pill v-on="on">
                {{ getCompanyInfo(project.CustNumber).Office_Name }}
              </v-chip>
            </template>
            <v-card width="300">
              <v-list dark>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      getCompanyInfo(project.CustNumber)
                        ? getCompanyInfo(project.CustNumber).Office_Name
                        : "Unnamed company"
                    }}</v-list-item-title>
                    <v-list-item-subtitle
                      >#{{ getCompanyInfo(project.CustNumber).CustNumber }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="menu[index] = false">
                      <v-icon>mdi-close-circle</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-action>
                  <v-list-item-subtitle>{{
                    getCompanyInfo(project.CustNumber).Office_Contact_Name
                  }}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-phone</v-icon>
                  </v-list-item-action>
                  <v-list-item-subtitle>{{
                    getCompanyInfo(project.CustNumber)
                      .Office_Contact_PhoneNumber
                  }}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-btn
                    @click="
                      $router.push(
                        '/company/' +
                          getCompanyInfo(project.CustNumber).CustNumber
                      )
                    "
                    block
                    text
                    >Edit</v-btn
                  >
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
          · {{ project.ProductModel || "No product" }} ·
          {{ project.ProductSerialNumber || "Unknown S/N" }}
        </v-card-text>
      </v-card>
      <br />
    </div>
    <br />
    <v-snackbar v-model="snackbar">
      {{ text }}
    </v-snackbar>
  </v-container>
</template>

<script>
var axios = require("axios").default;
var Header = require("@/components/HeaderComp.vue").default;

export default {
  name: "ProjectList",
  components: {
    Header,
  },
  data: () => ({
    drawer: false,
    group: 0,

    snackbar: false,
    text: "",

    companies: [],
    menu: {},
    allRequests: [],
    ongoingRequests: [],
    awaitingRequests: [],
    finishedRequests: [],
  }),
  methods: {
    // Get company info by CustNumber from this.companies
    getCompanyInfo: function (CustNumber) {
      for (var i = 0; i < this.companies.length; i++) {
        if (this.companies[i].CustNumber == CustNumber) {
          return this.companies[i];
        }
      }
    },
  },
  mounted() {
    var self = this;

    // Companies
    var data = JSON.stringify({
      token: localStorage.getItem("token"),
      table: "Companies",
    });

    var config = {
      method: "post",
      url: "https://aceapi.diconde.biz/database/query",
      headers: {
        Authorization: "Basic QWNlLS1QYW5lbDpBY2VATmw5MzAxWnY2LTM=",
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        self.companies = response.data;

        data = JSON.stringify({
          token: localStorage.getItem("token"),
          table: "ServiceRequests",
        });

        config = {
          method: "post",
          url: "https://aceapi.diconde.biz/database/query",
          headers: {
            Authorization: "Basic QWNlLS1QYW5lbDpBY2VATmw5MzAxWnY2LTM=",
            "Content-Type": "application/json",
          },
          data: data,
        };

        axios(config)
          .then(function (response) {
            console.log(JSON.stringify(response.data));
            self.allRequests = response.data;
            self.ongoingRequests = self.allRequests.filter(
              (project) => !project.Completed & !project.ActionClient
            );
            self.awaitingRequests = self.allRequests.filter(
              (project) => !project.Completed & project.ActionClient
            );
            self.finishedRequests = self.allRequests.filter(
              (project) => project.Completed
            );

            self.text =
              self.allRequests.length + " requests loaded successfully.";
            self.snackbar = true;
          })
          .catch(function (error) {
            console.log(error);
          });
      })
      .catch(function (error) {
        console.log(error);
      });
  },
};
</script>
